var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	54736: () => (loadStrictVersion("default", "@capacitor/core", false, [1,3,3,0], () => (__webpack_require__.e(6546).then(() => (() => (__webpack_require__(16546))))))),
	44914: () => (loadSingletonVersion("default", "react", false, [1,18,2,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	82797: () => (loadStrictVersion("default", "react-router", false, [1,5,2,0], () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(6347)]).then(() => (() => (__webpack_require__(56347))))))),
	12869: () => (loadStrictVersion("default", "@ionic/react", false, [1,5,5,0], () => (Promise.all([__webpack_require__.e(3567), __webpack_require__.e(7805), __webpack_require__.e(6672), __webpack_require__.e(6647), __webpack_require__.e(2434)]).then(() => (() => (__webpack_require__(7805))))))),
	64628: () => (loadStrictVersion("default", "react-router-dom", false, [1,5,2,0], () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(2797), __webpack_require__.e(7006)]).then(() => (() => (__webpack_require__(54625))))))),
	86672: () => (loadSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	36647: () => (loadStrictVersion("default", "ionicons", false, [1,5,4,0], () => (__webpack_require__.e(5842).then(() => (() => (__webpack_require__(85842))))))),
	31699: () => (loadStrictVersion("default", "redux", false, [1,4,1,0], () => (__webpack_require__.e(8067).then(() => (() => (__webpack_require__(38067))))))),
	36782: () => (loadSingletonVersion("default", "aws-amplify", false, [1,4,3,8], () => (Promise.all([__webpack_require__.e(3968), __webpack_require__.e(1687), __webpack_require__.e(6556), __webpack_require__.e(4839), __webpack_require__.e(4071), __webpack_require__.e(8451)]).then(() => (() => (__webpack_require__(95021))))))),
	67609: () => (loadStrictVersion("default", "@ionic/storage", false, [1,3,0,4], () => (__webpack_require__.e(9726).then(() => (() => (__webpack_require__(39726))))))),
	6869: () => (loadStrictVersion("default", "uuidv4", false, [1,6,2,11], () => (Promise.all([__webpack_require__.e(6556), __webpack_require__.e(537), __webpack_require__.e(9462)]).then(() => (() => (__webpack_require__(9462))))))),
	7252: () => (loadStrictVersion("default", "react-infinite-scroller", false, [1,1,2,4], () => (__webpack_require__.e(9039).then(() => (() => (__webpack_require__(81420))))))),
	20273: () => (loadStrictVersion("default", "dompurify", false, [1,3,4,0], () => (__webpack_require__.e(4997).then(() => (() => (__webpack_require__(84997))))))),
	195: () => (loadSingleton("default", "aws-amplify", false, () => (Promise.all([__webpack_require__.e(1687), __webpack_require__.e(6556), __webpack_require__.e(4839), __webpack_require__.e(4071), __webpack_require__.e(2634)]).then(() => (() => (__webpack_require__(95021))))))),
	5524: () => (loadStrictVersion("default", "scholarpresent-common-integration", false, [2,0,2,31], () => (__webpack_require__.e(3682).then(() => (() => (__webpack_require__(3682))))))),
	11925: () => (loadStrictVersion("default", "react-redux", false, [1,7,2,4], () => (__webpack_require__.e(1225).then(() => (() => (__webpack_require__(61225))))))),
	20884: () => (loadStrictVersion("default", "scholarpresent-message-integration", false, [2,0,2,17], () => (__webpack_require__.e(9098).then(() => (() => (__webpack_require__(29098))))))),
	39803: () => (loadStrictVersion("default", "react-quill", false, [1,2,0,0], () => (Promise.all([__webpack_require__.e(1687), __webpack_require__.e(5708)]).then(() => (() => (__webpack_require__(45708))))))),
	50835: () => (loadStrictVersion("default", "scholarpresent-platform-integration", false, [2,0,3,"00"], () => (__webpack_require__.e(2328).then(() => (() => (__webpack_require__(12328))))))),
	62317: () => (loadStrictVersion("default", "moment", false, [1,2,29,1], () => (__webpack_require__.e(5093).then(() => (() => (__webpack_require__(95093))))))),
	63532: () => (loadStrictVersion("default", "scholarpresent-document-integration", false, [3,0,0,1], () => (__webpack_require__.e(5153).then(() => (() => (__webpack_require__(67534))))))),
	71531: () => (loadStrictVersion("default", "rsuite", false, [1,4,11,1], () => (Promise.all([__webpack_require__.e(1687), __webpack_require__.e(4143), __webpack_require__.e(4839), __webpack_require__.e(2440)]).then(() => (() => (__webpack_require__(2440))))))),
	87607: () => (loadStrictVersion("default", "javascript-time-ago", false, [1,2,5,9], () => (__webpack_require__.e(4742).then(() => (() => (__webpack_require__(24742))))))),
	29514: () => (loadStrictVersion("default", "scholarpresent-channels-integration", false, [3,0,0,14], () => (__webpack_require__.e(5993).then(() => (() => (__webpack_require__(85993))))))),
	66021: () => (loadStrictVersion("default", "scholarpresent-contact-integration", false, [2,0,2,30], () => (Promise.all([__webpack_require__.e(6556), __webpack_require__.e(537), __webpack_require__.e(5169), __webpack_require__.e(1976)]).then(() => (() => (__webpack_require__(46983)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"64": [
		12869,
		64628
	],
	"1669": [
		67609,
		29514,
		66021
	],
	"1699": [
		31699
	],
	"2264": [
		7252,
		20273
	],
	"2460": [
		195,
		5524,
		11925,
		20884,
		39803,
		50835,
		62317,
		63532,
		71531,
		87607
	],
	"2797": [
		82797
	],
	"4736": [
		54736
	],
	"4914": [
		44914
	],
	"6647": [
		36647
	],
	"6672": [
		86672
	],
	"6782": [
		36782
	],
	"6869": [
		6869
	],
	"7609": [
		67609
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}